import { render, staticRenderFns } from "./selfCheckingAbnormal.vue?vue&type=template&id=28d4997e&scoped=true"
import script from "./selfCheckingAbnormal.vue?vue&type=script&lang=js"
export * from "./selfCheckingAbnormal.vue?vue&type=script&lang=js"
import style0 from "./selfCheckingAbnormal.vue?vue&type=style&index=0&id=28d4997e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d4997e",
  null
  
)

export default component.exports